import BasicResources from './basic-resources';

// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should call its initialise() method, to set
// up the environment and create all of the resources the application will use.

class Resources {
    static createResources(parentEnv) {
        const env = parentEnv || Resources.env;
        const baseUrl = '@CurriculumManagerGatewayUrl';

        /**
         * CONFIG
         */
        Resources.getConfigurationItem = async key => env.getConfigurationItem(key);

        /**
         * COUNTRIES
         */
        this.countries = env.resource('countries')
            .baseUrl(baseUrl)
            .service('api/countries');
        this.countryPublications = env.resource('countryPublications')
            .baseUrl(baseUrl)
            .service('api/countries/{countryCode}/publications');
        this.countryStates = env.resource('countryStates')
            .baseUrl(baseUrl)
            .service('api/countries/{countryCode}/states');

        /**
         * MASTER COURSES
         */
        this.getMasterCourses = env.resource('getMasterCourses')
            .baseUrl(baseUrl)
            .service('api/mastercourses/filter');
        this.masterCourses = env.resource('masterCourses')
            .baseUrl(baseUrl)
            .service('api/masterCourses');
        this.masterCourseCountries = env.resource('masterCourseCountries')
            .baseUrl(baseUrl)
            .service('api/masterCourses/countries');
        this.masterCourseById = env.resource('masterCourseById')
            .baseUrl(baseUrl)
            .service('api/masterCourses/{masterCourseId}');

        /**
         * PUBLICATIONS
         */
        this.publicationDocuments = env.resource('publicationDocuments')
            .baseUrl(baseUrl)
            .service('api/publications/{publicationId}/documents');
        this.publications = env.resource('publications')
            .baseUrl(baseUrl)
            .service('api/publications/filter');

        /**
         * DOCUMENTS
         */
        this.documentSections = env.resource('documentSections')
            .baseUrl(baseUrl)
            .service('api/documents/{documentId}/sections');

        /**
         * SECTIONS
         */
        this.sectionDetail = env.resource('sectionDetail')
            .baseUrl(baseUrl)
            .service('api/sections/{sectionId}');

        /**
         * SUBJECTS
         */
        this.subjects = env.resource('subjects')
            .baseUrl(baseUrl)
            .service('api/Subjects');

        /**
         * FILE MANAGEMENT
         */
        this.getSectionFile = env.resource('getSectionFile')
            .baseUrl(baseUrl)
            .service('api/files/sections/{sectionId}/file');
        this.checkSectionFile = env.resource('checkSectionFile')
            .baseUrl(baseUrl)
            .service('api/files/sections/{sectionId}/file-info');
        this.deleteSectionFile = env.resource('deleteSectionFile')
            .baseUrl(baseUrl)
            .service('api/files/sections/{sectionId}');
        this.uploadSectionFile = env.resource('uploadSectionFile')
            .baseUrl(baseUrl)
            .service('api/files/sections/{sectionId}');
    }

    // Initialise the environment and resources, based on the provided
    // environment name.  We return the environment so the caller has
    // access to everything, in particular the authToken if one was
    // passed in the query parameters.
    static initialise(envName, credentials) {
        Resources.env = BasicResources.initialise(envName, credentials);

        Resources.createResources();

        return Resources.env;
    }
}

export default Resources;



// WEBPACK FOOTER //
// ./app/helpers/resources.js